<template>
  <div class="tt" :class="$mq">
    <img :src="require(`@/assets/images/footer/` + $config.tt_footer)" alt="" />
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.tt {
  &.sm,
  &.md {
    width: 100%;
    img {
      width: 80%;
    }
  }
}
</style>
